"use client"

import { createContext, use } from "react"

import type { PortalNavItem, PortalPagesIndex } from "@/lib/portal-content"

export type PortalChromeValue = {
  navigation: PortalNavItem[]
  pagesIndex: PortalPagesIndex
}

const PortalChromeContext = createContext<PortalChromeValue | null>(null)

export function PortalChromeProvider({
  navigation,
  pagesIndex,
  children,
}: PortalChromeValue & { children: React.ReactNode }) {
  return (
    <PortalChromeContext value={{ navigation, pagesIndex }}>
      {children}
    </PortalChromeContext>
  )
}

export function usePortalChrome(): PortalChromeValue {
  const value = use(PortalChromeContext)
  return (
    value ?? {
      navigation: [],
      pagesIndex: {},
    }
  )
}
